<div class="top-section-background" data-cy="manage-alerts-header">
  <ion-grid [fixed]="true">
    <ion-row
      *ngIf="
        platformService?.platformType === platformService?.platformEnum?.desktop
      "
      data-cy="desktop-breadcrumbs-row"
    >
      <ion-col>
        <app-breadcrumbs
          [breadcrumbs]="breadcrumbs"
          data-cy="manage-alerts-breadcrumbs"
        ></app-breadcrumbs>
      </ion-col>
    </ion-row>

    <ion-row data-cy="header-title-row">
      <ion-col>
        <div class="header-section">
          <h1 data-cy="manage-alerts-title-text">
            {{ 'i18n.pageTitles.manageAlerts' | translate }}
          </h1>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
